/**@description When sending a CATS record, this specifies the type of action it is. */
export enum CatsActionModeEnum {
  Insert = 'I',
  Update = 'U',
  Delete = 'D',
  Approval = 'A',
}

/**@description gives a comparable code for identifying which type of basic interface referenced */
export enum BasicInterfaceTypeEnum {
  Employee = 'em',
  Equipment = 'eq',
  ProductionEquipment = 'pe',
  ProductionQuantity = 'pq',
  ProductionText = 'pt',
}

/**@description The unique ZRecordType for CATS record */
export enum CatsRecordTypeEnum {
  EmployeeBillable = 'EMP',
  EmployeeNonBillable = 'NON',
  EmployeePerDiem = 'EPD',
  Equipment = 'EQP',
  ProductionEquipment = 'PEQ',
  ProductionQuantity = 'PQT',
  ProductionText = 'PTX',
}

/**@description Possible timesheet types for ZCATSTIMESHEET table*/
export enum TimesheetTypeEnum {
  Nonbillable = 'NB',
  TimeAndMaterial = 'TM',
  ContractPrice = 'CP',
  PerDiem = 'PD',
}

export enum CatsSourceSystemEnum {
  Office = 'OF',
  Shop = 'SH',
  DaveyTimeGeneric = 'DT',
}

//We can use a "const enum" here so that we only deal with the values as numbers/string and don't really care about the overall parent "type"
export const CatsStatusCodeEnum = {
  Created: 10,
  /**@description Also known as "released" */
  ReadyForApproval: 20,
  Approved: 30,
  ApprovedNotProcessed: 35,
  ChangedAfterApproval: 40,
  Canceled: 50,
} as const;

/**@description Specific bill code descriptions for certain error states*/
export const CatsNoBillCodeDescriptionEnum = {
  Unassigned: 'Unassigned',
  NotOnContract: 'Not On Contract',
  NoDefault: 'No Default',
} as const;
